import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@material-ui/core/Button";
import "./modal.css";
import metamaskImage from "../../images/metamask.png";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: 6,
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export const LoadingModal = ({open,setOpen,handleClose,handleOpen}) => {
  return (
      <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
          >
              <Box sx={modalStyle}>
                  <Typography
                      id="modal-modal-title"
                      variant="h6"
                      component="h2"
                  >
                      Please proceed with your transaction on metamask popup
                  </Typography>
                  <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                      <Box sx={{ display: "flex", justifyContent: "center" }}>
                          <CircularProgress />
                      </Box>
                  </Typography>
              </Box>
          </Modal>
  )
}

export const MessageModal = ({message,handleOpen,handleClose,open}) => {
  return (
      <div>
      {/* <Button onClick={handleOpen}>Open modal</Button> */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Transaction Message
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {message}<br/>
            {(message === 'Please Install Metamask First') ? 
            (
              <div style={{"display":"flex"}}>
                <a className="install-metamask" href="https://metamask.io/download/" target="_blank">Install Metamask</a>
                <img className="metamask-image" src={metamaskImage} alt="metamask"/>
              </div>
              ): ("")}
          </Typography>
        </Box>
      </Modal>
    </div>
  )
}